
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gA02fpqgtycYomkGMKSkk1m_45SavEgvFtPHVwNC_45UPzH4Meta } from "/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexL0Z8o6D_v9wjrXdj5snXGFCntZSAJo5ZhAAPfhmDfa8Meta } from "/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchbXAsbDxO0y_454RgrW9tiO07B9az9sMz71IOTs5kQuOu4Meta } from "/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexhEizsGZZiAPwRln0A6gNG1gXcB7Yu72swPjAqUnmpTAMeta } from "/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93scMd0gVJZrZpQCiKWd_45RVk4y_45qd8X_456IX_45G3BFvDLTAMeta } from "/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index6l_NAiwaeWbBK51gk1707FLae1x9enUBcXVPBTVLqqMMeta } from "/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93CJTwz4vxHOslASweSCODCyE2TNMzCkz5RVsts2UHIVIMeta } from "/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index0mjbCHStVM16kNC9_HkBYHHtozO_ppTNmjQ9Lwx5QIkMeta } from "/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_9360XHKpM5V9bQN_a9NvHkBKTca8PrJKcEAVQOtlxbsG4Meta } from "/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexed6Ekn7ml1qmjEpHArPw_3c0yrC3jmOFa010z7GWOQwMeta } from "/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexvFoJQirFrnWidaS3S_45UF7nK7V3v8SPe6QAf_45Ypz_45gz0Meta } from "/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index6l_NAiwaeWbBK51gk1707FLae1x9enUBcXVPBTVLqqMMeta || {},
    component: () => import("/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index0mjbCHStVM16kNC9_HkBYHHtozO_ppTNmjQ9Lwx5QIkMeta || {},
    component: () => import("/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexed6Ekn7ml1qmjEpHArPw_3c0yrC3jmOFa010z7GWOQwMeta || {},
    component: () => import("/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexvFoJQirFrnWidaS3S_45UF7nK7V3v8SPe6QAf_45Ypz_45gz0Meta || {},
    component: () => import("/codebuild/output/src2553870920/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]